module.exports = __webpack_public_path__ + "img/set.35e0358f.png";